import { useTheme } from "@mui/material/styles";
import clsx from "clsx";
import { handleKeyDown } from "core/model/accessibility/keyboardActions";
import { AssessmentSlug } from "core/types";
import { DISABLED_COLOR, TEXT_STEPPER } from "ds_legacy/materials/colors";
import { margin } from "ds_legacy/materials/metrics";
import { Body } from "ds_legacy/materials/typography";
import React from "react";
import styled from "styled-components";
import { DotWithBorder } from "../Dot";

export const StepContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${margin(0, 1)};
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  width: 100%;
`;

export type OnClickType = (
  e: React.MouseEvent<HTMLButtonElement>,
  name?: string,
) => void;

export type StepProps = {
  children: React.ReactNode;
  color?: string | null | undefined;
  isActive?: boolean;
  isDisabled?: boolean;
  isDone?: boolean;
  name?: string;
  onClick?: OnClickType;
  showDot?: boolean;
  slug?: AssessmentSlug;
};

export default function Step({
  children,
  color,
  isActive,
  isDisabled,
  isDone,
  name,
  onClick,
  showDot,
  slug,
}: StepProps) {
  const theme = useTheme();

  let stepColor = TEXT_STEPPER;
  if (isDisabled) {
    stepColor = DISABLED_COLOR;
  } else if (isActive === true || isDone === true) {
    stepColor = theme.palette.primary.main;
  }

  return (
    <StepContainer
      data-slug={slug}
      tabIndex={0}
      type="button"
      onClick={!isDisabled ? (e) => onClick?.(e, name) : undefined}
      onKeyDown={handleKeyDown({
        onConfirm: !isDisabled
          ? (e) =>
              onClick?.(
                e as unknown as React.MouseEvent<HTMLButtonElement>,
                name,
              )
          : undefined,
      })}
    >
      <Body
        className={clsx({ active: isActive })}
        color={stepColor}
        data-testid={name}
        fontWeight={isActive === true ? "bold" : "normal"}
        margin="unset"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {children}
      </Body>
      {showDot && <DotWithBorder color={color || undefined} />}
    </StepContainer>
  );
}
